import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';
import { svgUrl } from '../../utils/staticUrls';

const CesPricesStyles = css`
  .ces-badges-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
  }

  .ces-badge {
    height: 16px;
    border-radius: 0 0 0 4px;
    color: ${colors.white.shade1};
    font-size: ${typography.xs2};
    font-weight: 800;
    line-height: 16px;
    padding: 0 4px;
    background-color: ${colors.black.shade3};
  }

  .ces-badge-ces_black {
    background-color: ${colors.black.shade3};
    width: 66px;
  }

  .ces-badge-ces_oro {
    background: var(
      --oro,
      linear-gradient(
        280deg,
        ${colors.golden.shade1} 25.37%,
        ${colors.golden.shade2} 81.71%,
        ${colors.golden.shade3} 112.31%
      )
    );
    background-blend-mode: darken;
    width: 56px;
  }

  .ces-badge-ces_plata {
    width: 65px;
    background: linear-gradient(
      95deg,
      ${colors.silver.shade1} 7.86%,
      ${colors.silver.shade2} 47.08%,
      ${colors.silver.shade3} 61.58%
    );
    background-blend-mode: darken;
    color: ${colors.black.shade3};
  }

  .ces-discount-badge {
    height: 16px;
    background-color: ${colors.black.shade3};
    width: auto;
    border-radius: 0 4px 0 0;
    color: ${colors.white.shade1};
    font-size: ${typography.xs2};
    font-weight: 800;
    line-height: 16px;
    padding: 0 4px;
  }

  .ces-discount-badge-ces_black {
    background-color: ${colors.black.shade3};
  }

  .ces-discount-badge-ces_oro {
    background-color: ${colors.orange.shade5};
  }

  .ces-discount-badge-ces_plata {
    background-color: ${colors.gray.shade72};
    color: ${colors.black.shade3};
  }

  .cmr-price-container {
    margin-bottom: 20px;
  }

  .ces-unit-price-cmr {
    font-size: ${typography.xl3};
    line-height: 32px;
    font-weight: 700;

    &.CART {
      font-size: ${typography.xl};
    }
  }

  .ces-unit-cmr {
    font-size: ${typography.lg2};
    font-weight: 400;
    line-height: 20px;
  }

  .ces-unit-price-highest {
    font-size: ${typography.base};
    line-height: 20px;
    font-weight: 400;
    color: ${colors.gray.shade58};
    &.big-text {
      font-size: ${typography.lg1};
      line-height: 24px;
      font-weight: 400;
      color: ${colors.gray.shade58};
    }
    &.ces-unit-price-ces.PDP_MAIN {
      font-size: ${typography.xl3};
    }
    &.big-text.CART {
      font-size: ${typography.xl};
    }
  }

  .ces-unit-highest {
    font-size: ${typography.sm};
    line-height: 14px;
    font-weight: 400;
    color: ${colors.gray.shade58};
    &.big-text {
      font-size: ${typography.base};
      line-height: 16px;
      font-weight: 400;
      color: ${colors.gray.shade58};
    }
    &.ces-pro {
      font-size: ${typography.base};
    }
  }

  .ces-unit-price-ces {
    font-size: ${typography.xl2};
    line-height: 28px;
    font-weight: 700;
    &.big-text {
      font-size: 29px;
      line-height: 36px;
      font-weight: 700;
    }
    &.ces-pro {
      font-size: ${typography.xl3};
    }
    &.ces-unit-price-ces.big-text {
      font-size: ${typography.xl3};
    }
    &.ces-unit-price-ces.PDP_MAIN {
      font-size: ${typography.xl3};
    }
    &.big-text.CART {
      font-size: ${typography.xl};
    }
  }

  .ces-unit-ces {
    font-size: ${typography.base};
    line-height: 20px;
    font-weight: 400;
    &.big-text {
      font-size: ${typography.lg2};
      line-height: 20px;
      font-weight: 400;
    }
    &.ces-pro {
      font-size: ${typography.lg2};
    }
  }

  .unica-cmr-icon {
    background-image: url(${svgUrl('cmrIcon.svg')});
    height: 20px;
    width: 45px;
    display: inline-block;
    background-repeat: no-repeat;
    &.pe,
    &.co {
      background-image: url(${svgUrl('cmrIcon-alt.svg')});
      width: 65px;
      margin-right: 4px;
    }
  }

  .discount-badge-cmr-container {
    display: flex;
    flex-direction: row;
  }

  .wholesale-container {
    margin-top: 12px;
  }
`;

export { CesPricesStyles };
